<template>
  <div id="main">
    <div class="ticketinfo" v-show!="showinfo">
        <div id="ticket-info-name"> 
            {{this.ticketname}} <br />
        </div>
        <div id="ticket-info-playtime"> 
            时间：{{this.playtime}}
        </div>
        <div id="ticket-info-officename"> 
            地点：{{this.officename}}
        </div>
        <div id="ticket-info-seatnumber"> 
            座位：{{this.seatnumber}}
        </div>
    </div>

    <div class="infoimg" v-show!="showinfo">        
        <img class="img" :src="imageSrc" alt="Dynamic Image">
        <div class="infotip">{{info}}</div>
    </div>

    <div class="tabbar" v-show!="showinfo">
        <mt-tabbar v-model="selected" fixed='fixed'>
            <mt-tab-item id="ticketlist">
                <img slot="icon" src="../assets/home.png">
                首页
            </mt-tab-item>
            <mt-tab-item id="electicketlist">
                <img slot="icon" src="../assets/user.png">
                我的
            </mt-tab-item>
        </mt-tabbar>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import qs from 'qs';
import { MessageBox } from 'mint-ui';

export default {
  name: 'main',
  data () {
    return {
      imageSrc: require('../assets/info.png'),
      msg: '这里是在线购票',  
      selected: 'electicketlist',
      showinfo:false,
      info:'',
      openid:'',   
      wxbaseinfo:{
        name:'',
        departmnet:'',
        serial:'',
        prenum:'',
        visittime:''
      },
      ticketname:'',
      playtime:'',
      officename:'',
      seatnumber:'',
      idnumber:'',
      username:'',
      list:[]
    }
  },
  watch: {
    selected: function(newV, oldV) {
      // mt-tab-item id
    //   console.log('newV',newV);
        //   console.log(this.selected);
      // this.$router.push({name: newV});
      // 编程导航 参数对应routes里面的命名name
      this.$router.push({name: this.selected});
    }
  },
  created(){      
    // 1、从缓存读取身份证号、姓名
    var temopenid = localStorage.getItem('idnumber');
    var temname = localStorage.getItem('username');
    console.log(temopenid);
    console.log(temname);
    if(temopenid!='undefined'){
        // 缓存存在
        this.idnumber=temopenid;
        this.username=temname;
        // 加载电子票二维码
        this.loadelecticketlist();
    }
    // 跳转到个人信息页

  },
  methods:{
    // 获取电子票信息
    loadelecticketlist(){
        var api='http://shzjapi.romis.cn:59848/api/getqrcode?idnumber=' + this.idnumber;
        Axios.get(api).then((response)=>{            
            if(response.data.result=='false'){
                // 无记录
                // this.$router.push({path:'/err'});
                this.info=response.data.errmsg;
                // this.showinfo=true;
            }
            else{
                // 解码用                 
                this.showinfo=false;                
                this.imageSrc=response.data.qrcode;
                this.ticketname=response.data.ticketname;
                this.officename=response.data.officename;
                this.playtime=response.data.playtime;
                this.seatnumber=response.data.seatnumber;
                console.log('info',this.imageSrc);       
            }
        }).catch((err)=>{
            alert('ticketlist获取票务列表失败：' + err);
        })
    }
  }
}
</script>

<style>

#main,/*设置占满*/
html,
body {
  background-color: #dbdbdb;
  width: 100%;
  height: 100%;
  margin: 0;
}
.infoimg{
    /* background-color:red; */
    display: flex;
    align-items: center; /* 垂直居中 */
    justify-content: center; /* 水平居中 */
    height: 40vh; /* 根据需要设置高度 */
}
.ticketinfo{
  display: -moz-box;
  display: -webkit-box;
  /* border:solid 1px red; */
  -moz-box-orient: vertical;
  -webkit-box-orient: vertical;

  /* background-color: #f30303; */
  width: 90%;
  height: 200px;
  border-radius: 15px; 
  margin-left: 60px;
  /* color: rgb(0, 0, 0); 
  display: flex;
  justify-content: center;
  text-align: left;
  border-left: 50px; */
}
#ticket-info-name{
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  font-size: 1.5em;
  font-weight: bold;
  height: 30px;
}
#ticket-info-playtime,#ticket-info-officename,#ticket-info-seatnumber{
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  font-size: 1em;
  height: 30px;
}
/* .ticket-info-name{
  width: 100%;
  height: 30px;
  color: black;
  font-size: 5rem;
} */
.infomaina{
  width: 85%;
  height:110px;
  background-color:white;
  font-family: Arial; 
  border: 1px solid #f4f4f4; 
  border-radius: 6px; 
  padding: 10px 10px; 
  /* margin: 5%; */

  border: 1px solid #bfbfbf;
  box-shadow: 0px 3px 5px 2px #aaa;
  filter: opacity(60); 

  display: flex;
  flex-direction: row/column;
  flex-wrap: nowrap/wrap;
}
.mainimg{
    background-color: black;
    width:40%;
    height: 130px;
    /* background-repeat: no-repeat; */
    /* background-position: center; */
    background-size: cover;

    border-radius: 6px 0px 0px 6px; 

    margin: -10px auto -10px -10px ;
}
.detailinfo{
    background-color: white;
    width:60%;
    height: 100%;
    margin: 0;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap/wrap;
}
.info1{
    width: auto;
    height: 50%;
    flex-direction: row;
    flex-wrap: nowrap/wrap;
    display: flex;
    /* background-color: red; */
}
.info2{
    width: auto;
    height: 50%;
    flex-direction: row;
    flex-wrap:initial;
}
.img{
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}
.buttonx{
    width: 40%;
    padding: 0px;
    margin-right: 0px;
    justify-content: center;
    align-items: center;
    /* background-color: blue; */
}
.topinfo1{
    font-size: 16px;
    width: 85%;
    font-weight: bold;
    display: flex;
    flex-direction: column;
}
.titlex{
  font-size: 14px;
  width: 85%;
  font-weight: bold;
  /* background-color: green; */
}
.price{
    font-size: 18px;
    font-weight: bold;
    color: red;
}
.info2{
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    /* background-color: green; */
}
.bottoninfo1{
    width: 30%;
    height: 100%;
    display: flex; /* 设置为flex容器 */
   justify-content: center; /* 水平居中 */
   align-items: center; /* 垂直居中 */
    /* background-color: blue; */
}
.scoreinfo{
    font-size: 26px;
    color: rgb(134, 19, 241);
}
.leadinfo{
    height: 50%;
    width: 100%;
    font-size: 10px;
    display: flex; /* 设置为flex容器 */
   /* justify-content: center; 水平居中 */
   align-items: center; /* 垂直居中 */
    /* background-color: greenyellow; */
}
.datex{
    height: 50%;
    width: 100%;
    font-size: 10px;
    color: darkgray;
    /* background-color: red; */
}
.red{ 
  font-size: 20px;
  float:right; 
  width:80px; 
  color:red;
}
.orange{ 
  font-size: 20px;
  float:right; 
  width:80px; 
  color:orange;
}
.lightgrey{ 
  font-size: 20px;
  float:right; 
  width:80px; 
  color:lightgray;
}
.infodetail{
    top: 50px;
}

</style>


// WEBPACK FOOTER //
// src/components/Electicketlist.vue